import "./RncpRsCertifications.module.css";
import EnTeteDeNavigation from "@/reusable_sections/Header";
import Hospitals from "./sections/Hospitals";
import WhyChooseUs from "./sections/WhyChooseUs";
import CreationVsRenouvellement from "./sections/CreationVsRenouvellement";
import ReadyToTransformProject from "@/pages/PrivacyPolicy/sections/ReadyToTransformProject";
import Footer from "@/reusable_sections/Footer";
import Hero from "./sections/Hero";
import StartNewWorkout from "./sections/StartNewWorkout";
import ConsultingPhilosophy from "./sections/ConsultingPhilosophy";
import InfoColumns from "./sections/InfoColumns";
import HowItWorks from "./sections/HowItWorks";
export default function RncpRsCertificationsPage() {
  return <div>
      <EnTeteDeNavigation />
      <Hospitals />
      <Hero />
      <WhyChooseUs />
      <ConsultingPhilosophy />
      <InfoColumns />
      <HowItWorks />
      <CreationVsRenouvellement />
      <ReadyToTransformProject />
      <StartNewWorkout />
      <Footer />
    </div>;
}